import { render, staticRenderFns } from "./ShippingMethodEditDialog.vue?vue&type=template&id=d6707c90&scoped=true"
import script from "./ShippingMethodEditDialog.vue?vue&type=script&lang=js"
export * from "./ShippingMethodEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6707c90",
  null
  
)

export default component.exports